// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__2BZKu","slideInScale":"Map_slideInScale__9zzrw"};